module.exports = __webpack_public_path__ + "img/rise-vineyard-logo.ca362042.jpg";